import React from 'react';

const ImageToggle = ({
  activeField,
  handleFileUpload,
  uploading,
  images,
  handleRemoveImage
}) => {
  if (activeField !== 'image') return null;

  return (
    <div className="truck-upload-container">
      <label className="form-label">Upload Images (max 7)</label>

      <input type="file" accept="image/*" multiple onChange={handleFileUpload} />

      {uploading && <p className="truck-uploading-text">Uploading images...</p>}

      {images.length > 0 && (
        <div className="preview-gallery">
          {images.map((img, i) => (
            <div
              key={i}
              style={{ position: 'relative', display: 'inline-block' }}
            >
              <img
                src={img}
                alt={`Uploaded ${i}`}
                className="truck-preview-media"
              />

              <button
                type="button"
                onClick={() => handleRemoveImage(i)}
                style={{
                  position: 'absolute',
                  top: '-6px',
                  right: '-6px',
                  background: 'red',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '50%',
                  cursor: 'pointer',
                  width: '20px',
                  height: '20px',
                  fontSize: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                ✖
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ImageToggle;
